import { Point } from "geojson";

export enum EventType {
    Showjumping = 1,
    Dressage = 2,
    Eventing = 3,
    Endurance = 4,
    Polo = 5,
    Racing = 6
}

export class CompetitionEvent {
    startDate!: Date;
    endDate!: Date;
    location!: Point;
    locationName!: string;
    eventType!: EventType;
    eventRating!: string;
}